<!--DESKTOP-->
<sc-button [disabled]="disabledButton" [id]="buttonId" type="secondary" class="filter-button-desktop  d-none d-md-block" (onClick)="open()">
  <span>
    <sc-icon icon="list-filter" size="0_75" [class]="'mr-1'" *ngIf="count == 0"></sc-icon>

    <span 
    [ngClass]="disabledButton? 'filter-button-desktop--count-disabled' : 'filter-button-desktop--count'"
    *ngIf="count > 0">
      <span class="filter-button-desktop--count__number">
        {{count}}
      </span>
    </span>
      Filtros
  </span>
</sc-button>

<!--MOBILE-->
<div class="filter-button-mobile mobile-container d-md-none" (click)="open()" [id]="buttonId">
  <div>
    <span
    [ngClass]="disabledButton? 'filter-button-mobile--count-disabled' : 'filter-button-mobile--count'"
    *ngIf="count > 0">
      <span class="filter-button-mobile--count__number">
        {{count}}
      </span>
    </span>
    <sc-icon [ngClass]="disabledButton? 'filter-button-mobile--icon-disabled' : 'filter-button-mobile--icon'" icon="list-filter" size="1"></sc-icon>
  </div>
</div>

<!-- LATERAL PANEL -->
<sc-lateral-drawer-light-box 
  [class.show]="showLateralMenu"
  (close)="close()">
  <sc-lateral-drawer
    class="filter-container white-lateral-panel hide-close-on-mobile" 
    (close)="close()"
    [backArrowForMobile]="true"
    [isOpen]="showLateralMenu">
    <div class="filter-container__header">
      <span class="filter-container__header--title subtitle">
        Filtros
      </span>
    </div>
    <div class="filter-container__body">
      <ng-content></ng-content>
    </div>
    <div class="filter-container__footer d-flex">
      <div class="col-md-6">
        <sc-button type="primary" [id]="applyId" [disabled]="disabledApply" class="full-width" (onClick)="applyFilters()">Aplicar</sc-button>
      </div>
      <div class="col-md-6">
        <sc-button type="secondary" [id]="deleteId" [disabled]="disabledDelete" class="full-width" (onClick)="deleteFilters()">Borrar filtros</sc-button>
      </div>
    </div>
  </sc-lateral-drawer>
</sc-lateral-drawer-light-box >